module.exports = __webpack_public_path__ + "img/9.c7cf9654.png";